export var tick = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
export default tick;
